import { type EntityCategory } from "@digits-graphql/frontend/graphql-bearer"
import { uniqueBy } from "@digits-shared/helpers/filters"
import objectHelper from "@digits-shared/helpers/objectHelper"
import {
  convertHierarchicalDimensionTreeToFlatList,
  convertToHierarchicalDimensionTree,
  getHierarchicalDimensionAncestors,
} from "src/shared/helpers/hierarchicalDimensionHelper"

export function createCategoryAncestorMap(categories: EntityCategory[]): Map<string, string> {
  const entityCategories = categories
    .filter(uniqueBy((c) => c.id))
    .sort(objectHelper.compareObjectNames)
    .map<EntityCategory>((c) => ({
      ...c,
      __typename: "EntityCategory",
    }))

  const categoriesWithHierarchyData = convertHierarchicalDimensionTreeToFlatList<EntityCategory>(
    convertToHierarchicalDimensionTree(entityCategories, 0)
  )

  const categoryAncestors = categoriesWithHierarchyData.reduce((ancestorLookup, node) => {
    const ancestorCategories = getHierarchicalDimensionAncestors(node).map((a) => a.dimension)
    const categoryId = node.dimension.id
    ancestorLookup.set(categoryId, ancestorCategories)
    return ancestorLookup
  }, new Map<string, EntityCategory[]>())

  const categoryIdToHierarchyText = new Map<string, string>()
  Array.from(categoryAncestors.entries()).forEach(([id, ancestors]) => {
    const ancestorString = ancestors.map((anc) => anc.name).join(" ▸ ")
    categoryIdToHierarchyText.set(id, ancestorString)
  })
  return categoryIdToHierarchyText
}
